import React, { useState } from "react";
import Button, { ButtonColorTypes } from "../shared-components/Button";

import { PlusIcon } from "@heroicons/react/24/solid";
import ModalWebContentForm from "./ModalWebContentForm";
import { ReportSummaryItemApi } from "../api/Reports";
import { Item } from "../api/Items";

type Props = {
  handleAction: (action: "add" | "cancel", value: Item) => void;
  behaviors: string[];
  report: ReportSummaryItemApi;
  profileUUID: string;
};

const ButtonWebcontentAddNew = ({
  handleAction,
  behaviors,
  report,
  profileUUID,
}: Props) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <Button
        text={
          <div className="flex gap-2 border border-gray-400 px-4 py-2 rounded-lg text-gray-700">
            <PlusIcon className="w-3" />
            <span>Add Content</span>
          </div>
        }
        onClick={() => {
          setShowModal(true);
        }}
        className="w-19	h-8	max-w-xs max-h-9"
        colorType={ButtonColorTypes.custom}
      />
      <ModalWebContentForm
        showModal={showModal}
        close={(item?: Item) => {
          if (item) {
            handleAction("add", item);
          }
          setShowModal(false);
        }}
        behaviors={behaviors}
        initialState={{ report, profileUUID }}
        isNew={true}
      />
    </div>
  );
};

export default ButtonWebcontentAddNew;
